
  import { Component, Vue, Watch } from 'vue-property-decorator';
  import FacebookLogin from '@/components/FacebookLogin.vue';
  import axios from 'axios';
  import router from '@/router';
  import VSelectNoPointerScroll from '@/components/VSelectNoPointerScroll.vue';
  import settings from '../config';
  @Component({
    components: {
      FacebookLogin,
      VSelectNoPointerScroll,
    },
  })
  export default class AppInstall extends Vue {
    public validSelect = false;
    public validCode = false;
    public wrappedPages: any;

    public errors: any[] = [];
    public success = false;
    public activationCode = '';
    public busy = false;

    public install() {
      this.busy = true;
      const { id, access_token, name } = this.$store.state.selectedPage;
      const error = this.$t('install_page.error');
      const errorMsg = this.$t('install_page.error_detail');

      axios.post(settings.VUE_APP_BASE_URL + 'activation',
        {
          pageName: name,
          pageId: id,
          pageAccessToken: access_token,
          activationCode: this.activationCode,
          locale: this.$root.$i18n.locale,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
      .then((response) => {
        setTimeout( () => {
          this.success = true;
          this.busy = false;
          this.errors = [];
          router.push('Finished');
        }, 3000);
      })
      .catch((e) => {
        this.errors = [];
        if (e && e.response && e.response.data) {
          this.errors.push({
            error: `${e.response.data.error || error}`,
            errorDetails: ` ${e.response.data.errorDetails || errorMsg}`,
          });
        } else {
          this.errors.push(errorMsg);
        }
        this.busy = false;
      });
    }

    @Watch('activationCode')
    public updateValidCode() {
      this.validCode = this.activationCode != null &&
        this.activationCode.trim() !== '';
    }
  }
